import InputSearchIcon from "../../common/searchInput";
import styles from "./property-listing.module.scss";
import DropdownC from "../../common/dropdown";
import { useEffect, useRef, useState } from "react";
import {
  occupancy,
  offMarket,
  PossessionDelivery,
  salesInstructions,
  sortByOptions,
  states,
  statusOption
} from "./sidebar";
import { DataViewLayoutOptions } from "primereact/dataview";
import ButtonC from "../../common/button";
import { useLocation, useSearchParams } from "react-router-dom";
import { ToggleView } from "../../investor/amplitude";
import { InputText } from "primereact/inputtext";
import { useDebounce } from "primereact/hooks";

const INITIAL_VALUE = {
  state: null,
  offMarket: null,
  occupancy: null,
  salesInstructions: null,
  status: null,
  possessionDelivery: null,
  Layout: null,
  sort: null
};

const StartContent = ({
  searchValue,
  debouncedSearchValue,
  setSearchValue,
  type
}: any) => {
  // const
  const [, setSearchParams] = useSearchParams();
  const [stateValue, setValue] = useState<any>(INITIAL_VALUE);
  const itemsRef: any = useRef<any>([]);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParamsObject: any = {};
    params.forEach((value, key) => {
      searchParamsObject[key] = value;
    });

    const newStateValue: any = {
      state:
        states().find((s: any) => s.name === searchParamsObject.state) || null,
      offMarket:
        offMarket().find((s: any) => s.name === searchParamsObject.offMarket) ||
        null,
      occupancy:
        occupancy().find((s: any) => s.name === searchParamsObject.occupancy) ||
        null,
      salesInstructions:
        salesInstructions().find(
          (s: any) => s.name === searchParamsObject.salesInstructions
        ) || null,
      status:
        statusOption().find((s: any) => s.name === searchParamsObject.status) ||
        null,
      possessionDelivery:
        PossessionDelivery().find(
          (s: any) => s.name === searchParamsObject.possessionDelivery
        ) || null,
      sort:
        sortByOptions.find((s) => s.name === searchParamsObject.sort) || null
    };

    if (JSON.stringify(stateValue) !== JSON.stringify(newStateValue)) {
      setValue(newStateValue);
    }

    const updatedParams = new URLSearchParams(location.search);

    if (debouncedSearchValue) {
      updatedParams.set("searchText", debouncedSearchValue);
    } else {
      updatedParams.delete("searchText");
    }

    if (newStateValue.sort?.name) {
      updatedParams.set("sort", newStateValue.sort.name);
    } else {
      updatedParams.delete("sort");
    }

    Object.keys(newStateValue).forEach((key) => {
      if (key === "sort") return;
      if (newStateValue[key]?.name) {
        updatedParams.set(key, newStateValue[key].name);
      } else {
        updatedParams.delete(key);
      }
    });

    setSearchParams(updatedParams, { replace: true });
  }, [location.search, debouncedSearchValue, setSearchParams, stateValue]);

  function handleChange(name: string, value: string) {
    setValue((stateValue: any) => {
      const updatedState: any = {
        ...stateValue,
        [name]: value
      };

      if (name === "searchText") {
        setSearchValue(value);
      }

      const updatedParams = new URLSearchParams(location.search);

      if (debouncedSearchValue) {
        updatedParams.set("searchText", debouncedSearchValue);
      } else {
        updatedParams.delete("searchText");
      }

      Object.keys(updatedState).forEach((key) => {
        if (key !== "searchText" && updatedState[key]?.name) {
          updatedParams.set(key, updatedState[key].name);
        } else if (key !== "searchText" && !updatedState[key]?.name) {
          updatedParams.delete(key); // Remove parameter if value is undefined
        }
      });
      setSearchParams(updatedParams);
      localStorage.setItem("filter", JSON.stringify(updatedState));
      return updatedState;
    });
  }

  const resetSearch = () => {
    setValue(INITIAL_VALUE);
    setSearchValue("");
    const updatedParams = new URLSearchParams(location.search);
    updatedParams.delete("searchText");
    updatedParams.delete("sort");
    Object.keys(INITIAL_VALUE).forEach((key) => {
      if (key !== "sort") {
        updatedParams.delete(key);
      }
    });
    setSearchParams(updatedParams, { replace: true });
  };
  const togglePanel = (index: any) => {
    // eslint-disable-next-line array-callback-return
    itemsRef.current.map((item: any) => {
      if (item === itemsRef.current[index]) {
        // item.show();
      } else {
        item.hide();
      }
    });
  };

  return (
    <div className={styles.filterWrap}>
      <div tabIndex={1}>
        <InputSearchIcon
          placeholder="Address, City or ZIP"
          className={styles.inputBox}
          searchIcon={true}
          name="searchText"
          value={searchValue}
          resetSearch={() => setSearchValue("")}
          onChange={(e: any) => handleChange("searchText", e.target.value)}
        />
      </div>
      {type === "agent" && (
        <>
          <DropdownC
            placeholder="State"
            showClear={true}
            className={`${styles.dropdownBox} ${styles.State}`}
            panelClassName={styles.dropdownList}
            tabIndex={0}
            options={states()}
            optionLabel="name"
            name="state"
            onChange={(e: any) => {
              handleChange("state", e?.value);
            }}
            value={stateValue.state}
            selectColor={true}
            ref={(el) => (itemsRef.current[0] = el)}
            togglePanel={togglePanel}
            index={0}
          />
          <DropdownC
            placeholder="Off Market"
            showClear={true}
            className={`${styles.dropdownBox} ${styles.Market}`}
            panelClassName={styles.dropdownList}
            tabIndex={1}
            options={offMarket()}
            name="offMarket"
            optionLabel="name"
            onChange={(e: any) => {
              handleChange("offMarket", e?.value);
            }}
            value={stateValue.offMarket}
            selectColor={true}
            togglePanel={togglePanel}
            ref={(el) => (itemsRef.current[1] = el)}
            index={1}
          />
          <DropdownC
            placeholder="Sales Instructions"
            className={`${styles.dropdownBox} ${styles.Sales}`}
            panelClassName={styles.dropdownList}
            tabIndex={3}
            name="salesInstructions"
            options={salesInstructions()}
            optionLabel="name"
            showClear={true}
            onChange={(e: any) => {
              handleChange("salesInstructions", e?.value);
            }}
            value={stateValue.salesInstructions}
            selectColor={true}
            ref={(el) => (itemsRef.current[2] = el)}
            index={2}
            togglePanel={togglePanel}
          />
          <DropdownC
            name="occupancy"
            placeholder="Occupancy"
            className={`${styles.dropdownBox} ${styles.Occupancy}`}
            panelClassName={styles.dropdownList}
            tabIndex={4}
            options={occupancy()}
            showClear={true}
            optionLabel="name"
            onChange={(e: any) => {
              handleChange("occupancy", e?.value);
            }}
            value={stateValue.occupancy}
            selectColor={true}
            ref={(el) => (itemsRef.current[3] = el)}
            index={3}
            togglePanel={togglePanel}
          />
          <DropdownC
            showClear={true}
            name="possessionDelivery"
            placeholder="Possession/Delivery"
            className={`${styles.dropdownBox} ${styles.Possession}`}
            panelClassName={styles.dropdownList}
            tabIndex={4}
            options={PossessionDelivery()}
            optionLabel="name"
            onChange={(e: any) => {
              handleChange("possessionDelivery", e?.value);
            }}
            value={stateValue.possessionDelivery}
            selectColor={true}
            ref={(el) => (itemsRef.current[4] = el)}
            index={4}
            togglePanel={togglePanel}
          />
          <DropdownC
            name="status"
            showClear={true}
            placeholder="Status"
            className={`${styles.dropdownBox} ${styles.Status}`}
            panelClassName={styles.dropdownList}
            tabIndex={5}
            options={statusOption()}
            optionLabel="name"
            onChange={(e: any) => {
              handleChange("status", e?.value);
            }}
            value={stateValue.status}
            selectColor={true}
            ref={(el) => (itemsRef.current[5] = el)}
            index={5}
            togglePanel={togglePanel}
          />
          <ButtonC
            label="Reset"
            btnType="link"
            className={styles.ResetButton}
            onClick={resetSearch}
          />
        </>
      )}
    </div>
  );
};

const Header = ({
  layout,
  setLayout,
  searchValue,
  setSearchValue,
  debouncedSearchValue,
  type
}: {
  layout: any;
  searchValue: string;
  debouncedSearchValue: string;
  setSearchValue: (searchValue: string) => void;
  setLayout: (value: any) => void;
  type: string;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSearchMenuOpen, setIsSearchMenuOpen] = useState(false);
  
  // Show pre-search only when pre toggle (showPre) is on for agents
  const isPreOn =
    type === "agent" && (searchParams.get("showPre") === null
      ? true
      : searchParams.get("showPre") === "true");
  
  // Search state with debounce (only for agents)
  const [preSearchValue, debouncedPreSearchValue, setPreSearchValue] = useDebounce(
    type === "agent" ? searchParams.get("searchTxtPre") || "" : "",
    500
  );

  // Update URL params when debounced pre-search value changes - only for agents
  useEffect(() => {
    if (type !== "agent") return;

    const updatedParams = new URLSearchParams(searchParams);

    if (debouncedPreSearchValue) {
      updatedParams.set("searchTxtPre", debouncedPreSearchValue);
    } else {
      updatedParams.delete("searchTxtPre");
    }

    setSearchParams(updatedParams);
  }, [debouncedPreSearchValue, searchParams, setSearchParams, type]);

  // Close menu if pre toggle turned off
  useEffect(() => {
    if (!isPreOn && isSearchMenuOpen) {
      setIsSearchMenuOpen(false);
    }
  }, [isPreOn, isSearchMenuOpen]);

  function changeLayout(e: any) {
    setLayout(e.value);
    localStorage.setItem("layout", e.value);
    if (type === "investor") {
      ToggleView(e.value);
    }
  }

  const toggleSearchMenu = () => {
    setIsSearchMenuOpen(!isSearchMenuOpen);
  };

  const handlePreSearchChange = (e: any) => {
    setPreSearchValue(e.target.value);
  };

  const clearPreSearch = () => {
    setPreSearchValue("");
  };

  return (
    <div className={styles.headerWrap}>
      <StartContent
        type={type}
        searchValue={searchValue}
        debouncedSearchValue={debouncedSearchValue}
        setSearchValue={setSearchValue}
      />
      <div className={styles.searchIconContainer}>
        {isPreOn && (
          <img 
            src="/images/pre-search.svg" 
            alt="pre-search" 
            className={styles.preSearchIcon} 
            onClick={toggleSearchMenu}
          />
        )}
        {isSearchMenuOpen && isPreOn && (
          <div className={styles.floatingSearchContainer}>
            {preSearchValue?.length > 0 ? (
              <i
                className={`pi pi-times-circle ${styles.floatingSearchIcon}`}
                onClick={clearPreSearch}
              />
            ) : (
              <img
                src="/images/search.svg"
                alt="search"
                className={styles.floatingSearchIcon}
              />
            )}
            <InputText
              className={styles.floatingSearchInput}
              placeholder="Search on Account, Entities and address"
              value={preSearchValue}
              onChange={handlePreSearchChange}
              type="text"
            />
          </div>
        )}
      </div>
      <DataViewLayoutOptions layout={layout} onChange={changeLayout} />
    </div>
  );
};

export default Header;
